import { createRouter, createWebHistory } from "vue-router";
import store from "../store";
import LoginRoutes from "../modules/login/index";
import HomeRoutes from "../modules/home/index";
import NotFound from "../modules/NotFound/index";
import RegisterRoutes from "../modules/userRegister/index";
import ContactUsRoutes from "../modules/contact-us/index";
import PlayerRoutes from "../modules/player/index";
import PendingVerificationRoutes from "../modules/pendingVerification/index";
import ClientSelectorRoutes from "../modules/client-selector/index"; 
import UserManagementRoutes from "../modules/userManagement/router/usermanagement";

const list = [
  ...LoginRoutes,
  ...HomeRoutes,
  ...RegisterRoutes,
  ...NotFound,
  ...ContactUsRoutes,
  ...PlayerRoutes,
  ...PendingVerificationRoutes,
  ...ClientSelectorRoutes,
  ...UserManagementRoutes
];

let routes = [];

list.forEach((items) => {
  if (Array.isArray(items)) {
    items.forEach((item) => {
      routes.push(item);
    });
  } else {
    routes.push(items);
  }
});

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const needAuth = to.meta.requireAuth;
  const needAuceraUser = to.meta.requireAuceraUser;
  const isLogged = store.state.auth.loggedIn;
  // If not logged in, only block routes that need auth
  if (!isLogged) {
    if (needAuth) {
      // Only stores redirect if it’s not the NotFound route
      if (to.name !== "notFound") {
        localStorage.setItem("postLoginRedirect", to.fullPath);
      }
      return next({ path: "/login" });
    } else {
      return next();
    }
  }
  // If logged in, check the token’s isActive flag
  const accessToken = localStorage.getItem("access_token");
  let isActive = true;
  let isAdmin = false;
  let isSupport = false;
  let isAuceraUser = false; 

  if (accessToken) {
    try {
      const payloadBase64 = accessToken.split(".")[1];
      const payloadJson = JSON.parse(atob(payloadBase64));
      isActive = payloadJson.extension_IsActive;
      const roles = String(payloadJson.extension_Roles || "").toLowerCase();
      isSupport = roles.includes("support");
      isAdmin = roles.includes("admin");
      const clientName = (payloadJson.extension_ClientName || "").toString().toLowerCase();
      isAuceraUser = clientName == "aucera";
    } catch (e) {
      console.error("Error decoding token payload:", e);
      isActive = false;
    }
  } else {
    isActive = false;
  }
  const isInactive = isActive === false || isActive === undefined || isActive === null;
  if (isInactive) {
    if (to.path === "/login" || to.path === "/pending-verification") {
      next();
    } else {
      next({ path: "/pending-verification" });
    }
    return;
  } 

    // Block non-admin users from accessing admin routes
    if (needAuceraUser) {
      const allowed = isAuceraUser && (isAdmin || isSupport);
      if (!allowed) {
        return next({ path: "/" });
    }
  }

    const selectedClientCode = localStorage.getItem("selectedClientCode");
      if (
        (isAuceraUser && (isAdmin || isSupport)) &&
        !selectedClientCode &&
        to.path !== "/client-selector" &&
        to.path !== "/login"
      ) {
        // Save intended route so client selector knows where to route after selection
        localStorage.setItem("pendingTargetAfterClientSelect", to.fullPath);
        return next({ path: "/client-selector" });
      }
  else {
    next();
  }
 });

 router.afterEach(() => {
  if (
    window.location.hash.includes("access_token") ||
    window.location.hash.includes("id_token")
  ) {
    window.history.replaceState(null, document.title, window.location.pathname);
  }
});
 export default router;